<template>
  <div class="export-loader">
    <div class="export-loader__wrapper">
      <div class="export-loader__text">{{ text }}</div>
      <div class="loader"></div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'ExportLoader',
  props: ['text']
}
</script>

<style lang="scss" scoped>
  @import "src/scss/variables";

  .export-loader {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    
    &__wrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 30px;
      width: 300px;
      text-align: center;
      border-radius: 5px;
    }

    @media print {    
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/ExportLoader.vue